import { isDisposable } from '../../common/type-guards/disposable';
import { DataProxyService } from './data-proxy.service';

/**
 * Used to manage proxy instances so data doesn't get shared between multiple forms.
 */
export class DataProxyInstanceService {
  private static instances: Record<string, DataProxyService> = {};

  /**
   * Gets or creates a DataProxy service instance.
   * @param {string} instanceKey - The key used to determine if the instance exists.
   * @returns {DataProxyService} Returns the DataProxy service.
   */
  public static getServiceInstance(instanceKey: string) {
    if (!DataProxyInstanceService.containsInstance(instanceKey)) {
      DataProxyInstanceService.instances[instanceKey] = new DataProxyService();
    }

    return DataProxyInstanceService.instances[instanceKey];
  }

  /**
   * Removes a DataProxy service instance from the collection.
   * @param {string} instanceKey - The instance key to remove.
   */
  public static removeServiceInstance(instanceKey: string) {
    if (DataProxyInstanceService.containsInstance(instanceKey)) {
      const instance = DataProxyInstanceService.instances[instanceKey];
      if (isDisposable(instance)) {
        instance.dispose();
      }

      delete DataProxyInstanceService.instances[instanceKey];
    }
  }

  public static removeAllServiceInstances() {
    const instanceKeys = Object.keys(DataProxyInstanceService.instances);
    for (let i = 0, length = instanceKeys.length; i < length; i++) {
      const instance = DataProxyInstanceService.instances[instanceKeys[i]];
      if (isDisposable(instance)) {
        instance.dispose();
      }

      delete DataProxyInstanceService.instances[instanceKeys[i]];
    }
  }

  private static containsInstance(instanceKey: string) {
    return DataProxyInstanceService.instances[instanceKey] !== undefined;
  }
}
